import React, { Component } from 'react';

class Nav extends Component {
  render() {
    const { items: navItems } = this.props;
    return (
      <nav>
        <div className="column row">
          <ul data-magellan data-bar-offset="-25">
            { navItems.map(navItem => {
              return (
                <li key={navItem.slug}>
                  <a href={`#${navItem.slug}`}>{navItem.title}</a>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
    );
  }
};

// NEEDS TO BE EXPORTS!!
module.exports = Nav;



// WEBPACK FOOTER //
// ./templates/views/components/nav.jsx